<template>
  <div>
  <b-card v-if="isNotEmpty" class="no-border">
    <b-form>
      <div class="form-group flex-inline-form-md">
        <div class="fill-width">
          <h3>Order Routing &bull; {{ shipmentDateHuman }}</h3>
        </div>
        <!-- <b-input-group class="fill-width">
          <b-input-group-text slot="prepend">
            <i class="fa fa-search"></i>
          </b-input-group-text>
          <b-form-input type="text" placeholder="Search order by order number" v-model="searchQuery"></b-form-input>
        </b-input-group> -->
        <date-picker
          confirm
          :editable="false"
          :clearable="false"
          :shortcuts="false"
          lang="en"
          v-model="selectedDate"
          type="date"
          @confirm="onConfirmDate"
          format="DD MMM YYYY"
        >
        </date-picker>
        <b-input-group v-if="hasOrders && canRestart">
          <b-button @click="restartData" title="Restart" variant="light" class="w-100">
            Restart
            &nbsp;<i class="fa fa-refresh"></i>
          </b-button>
        </b-input-group>
        <b-input-group v-if="!availableShipmentData">
          <b-button title="Upload File" v-b-toggle.upload-container variant="light" class="w-100">
            Upload
            &nbsp;<i class="fa fa-upload"></i>
          </b-button>
        </b-input-group>
        <b-input-group v-if="unassignedOrder > 0 && shipments.length === 0">
           <b-button @click="calculateRoute" title="Calculate Route" variant="light" class="w-100">
             Calculate Route
             &nbsp;<i class="fa fa-calculator"></i>
            </b-button>
        </b-input-group>
        <b-input-group v-if="availableShipmentData">
          <b-button @click="showMapModal('all')" title="Preview Route" variant="light" class="w-100"><i class="fa fa-map-pin"></i></b-button>
        </b-input-group>
      </div>
    </b-form>
    <div class="row">
      <div class="col-xl-9 col-lg-7"></div>
      <div class="col-xl-3 col-lg-5">
        <b-collapse id="upload-container">
          <b-card>
            <b-form v-on:submit.prevent="onSubmitUpload">
              <div v-show="!uploadProcessed">
                <b-form-file class="mb-2" ref="fileInput" :multiple="false" :state="Boolean(fileUpload)" v-model="fileUpload" name="fileInput" accept=".xml, .xls, .xlsx"></b-form-file>
                <p v-if="hasOrders" class="text-info">Warning, orders with the same numbers will be replaced!</p>
                <div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input class="my-checkbox" type="checkbox" v-model="fileUploadCreateShipment">
                      Create shipment from routing data
                    </label>
                  </div>
                </div>
              </div>
              <b-alert show v-show="uploadProcessed" v-bind:variant="uploadAlert">
                <p style="margin-bottom: 0px;">
                  {{ uploadResultText }}
                  <a href="#" v-on:click.prevent="uploadProcessed = false; uploadText = 'Start Upload'; isUploadError = false;" class="alert-link">Upload again.</a>
                </p>
              </b-alert>
              <!-- <b-alert show v-show="isUploadError" variant="danger">
                <p style="margin-bottom: 0px;">With Error Message: </p>
                <p style="margin-bottom: 0px;">
                  <ul class="pl-3 mb-0">
                    <li v-for="i in errorResultText" :key="i">{{ i }}</li>
                  </ul>
                </p>
              </b-alert> -->
              <hr>
              <b-button :disabled="noFileUploadChosen" type="submit" variant="primary">{{uploadText}}</b-button>
              <b-button
                @click="cancelUpload()"
                v-b-toggle="'upload-container'"
                type="reset"
                variant="outline-danger"
                class="pull-right">Cancel</b-button>
            </b-form>
          </b-card>
        </b-collapse>
      </div>
    </div>
    <b-card v-if="routing_summary.filter(s => s.count > 0).length">
      <div class="panel-heading">
        <b-row align-h="between">
          <b-col md="4">
            <h4 class="panel-title">Routing Summary</h4>
          </b-col>
        </b-row>
      </div>
      <b-card-text>
        <p>
          <b style="font-size: 18px;">Delivery Date: <span class="text-info">{{ dateFormat(selectedDate, 'DD MMM YYYY') }}</span></b>
          <br>
          <b style="font-size: 18px;">
            Total PL: <span class="text-info">{{ totalOrdersPL }} Orders</span> |
            Assigned: <span class="text-info">{{ assignedOrder }} Orders ({{ shipmentsHasJob.length }} Trucks)</span> |
            Unassigned: <span class="text-info">{{ onCallOrder + invalidDestinationOrder + unassignedOrder }} Orders ({{ shipmentsNoJob.length }} Trucks)</span>
          </b>
          <br>
          <b style="font-size: 18px;">
            Out of Area: <span class="text-danger">{{ onCallOrder }} Orders</span> |
            No Location: <span class="text-danger">{{ invalidDestinationOrder }} Orders</span> |
            Other: <span class="text-danger">{{ unassignedOrder }} Orders</span>
          </b>
        </p>
      </b-card-text>
    </b-card>
    <div v-else-if="!routingSummaryLoading">
      <b-alert show variant="primary">No order has been created. Please upload a new orders file.</b-alert>
    </div>
    <div v-else>
      <b-overlay show>
        <div style="height:100px"> </div>
      </b-overlay>
    </div>
    <b-card v-if="routing_summary.filter(s => s.count > 0).length" class="mt-6">
      <b-form class="form-group form-group-lg">
        <div class="panel-heading">
          <b-row align-h="between">
            <b-col md="2">
              <h3 class="panel-title">Shipments</h3>
            </b-col>
            <b-col md="3">
              <multiselect
                v-model="storageSelected"
                placeholder="Select type"
                :options="storageList"
                :multiple="true"
                :clear-on-select="false"
                :preserve-search="true"
                :close-on-select="false">
                <template slot="tag"><span></span></template>
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.join(', ') }}</span>
                </template>
              </multiselect>
            </b-col>
            <b-col md="3" v-if="isTunas">
              <multiselect
                v-model="areaSelected"
                placeholder="Select area"
                :options="areaList"
                :multiple="true"
                :clear-on-select="false"
                :preserve-search="true"
                :close-on-select="false">
                <template slot="tag"><span></span></template>
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} area selected</span>
                </template>
              </multiselect>
            </b-col>
            <b-col md="4">
              <div class="pull-right">
                <b-button
                  @click="openModalChange"
                  title="Change Delivery Date"
                  class="mb-2"
                  variant="outline-primary"
                  v-if="hasOrdersNotAssigned"
                >
                Change Delivery Date
                  &nbsp;<i class="fa fa-plus-calendar"></i>
                </b-button>
                <b-button
                  @click="addOrder"
                  title="Add Order"
                  class="mb-2"
                  variant="outline-primary"
                  v-if="availableShipmentData"
                >
                Add Order
                  &nbsp;<i class="fa fa-plus-square"></i>
                </b-button>
                <b-button
                  @click="resetRoute"
                  title="Reset"
                  class="mb-2"
                  variant="outline-primary"
                  v-if="availableShipmentData"
                >
                Reset
                  &nbsp;<i class="fa fa-reply"></i>
                </b-button>
                <b-button
                  class="mb-2"
                  @click="setReadyToLoad"
                  title="Set Ready To Load"
                  variant="outline-primary"
                  v-if="availableShipmentData"
                >
                Finish
                  &nbsp;<i class="fa fa-check"></i>
                </b-button>
                <b-button
                  @click="startExportShipments"
                  title="Export shipments to excel"
                  variant="outline-primary"
                  class="mb-2">
                  Export
                  &nbsp;<i class="fa fa-file-excel-o"></i>
                </b-button>
                <b-button
                  :title="shipmentListViewMode ? 'Switch mode to compact view' : 'Switch mode to list view'"
                  class="mb-2"
                  @click="shipmentListViewMode = !shipmentListViewMode"
                  variant="outline-primary">
                  <span v-if="shipmentListViewMode">
                    <i class="fa fa-qrcode"></i>
                  </span>
                  <span v-else>
                    <i class="fa fa-navicon"></i>
                  </span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-form>
      <b-alert
        :show="alertExportedShipment"
        :variant="resultExportedShipment ? 'success' : 'danger'"
        @dismissed="alertExportedShipment=false"
        dismissible fade>
        <span v-if="resultExportedShipment">
          Success export shipments. <a :href="linkFileExportShipment" download><b> Download</b></a>
        </span>
        <span v-else>
          Failed export shipments :(
        </span>
      </b-alert>
      <hr>
      <div v-if="shipmentListViewMode" class="list-view-mode-container">
        <b-row align-h="between" class="mb-2">
          <b-col md="3">
            <b-form-group
              label="Filter"
              label-for="filter-input"
              label-cols-sm="3"
              label-align-sm="left"
              class="mb-0"
            >
              <b-input-group>
                <b-form-input
                  id="filter-input"
                  v-model="shipmentListTable.filter"
                  type="search"
                  placeholder="Type to Search"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              label="Per page"
              label-for="per-page-select"
              label-cols-sm="6"
              label-cols-md="4"
              label-cols-lg="3"
              label-align-sm="right"
              class="mb-0"
            >
              <b-form-select
                id="per-page-select"
                v-model="shipmentListTable.perPage"
                :options="shipmentListTable.pageOptions"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-table
          responsive
          :filter="shipmentListTable.filter"
          :current-page="shipmentListTable.currentPage"
          :per-page="shipmentListTable.perPage"
          :items="shipmentListTable.items"
          :fields="shipmentListTable.fields">
          <template #cell(index)="row">
            <b>{{ row.value }}</b>
          </template>
          <template #cell(number)="row">
            <router-link :to="`/shipment_md/shipments/${row.item.id}`">{{row.value}}</router-link>
          </template>
          <template #cell(driver)="row">
            {{ get(row.value, 'name') }}
          </template>
          <template #cell(vehicle)="row">
            <router-link :to="`/vehicles/${get(row, 'item.vehicle.id')}`">{{ get(row.value, 'reg_no') }}</router-link>
          </template>
          <template #cell(duration)="row">
            {{ formatDuration(row.item) || '-' }}
          </template>
          <template #cell(distance)="row">
            {{ formatDistance(row.item) || '-' }}
          </template>
          <template #cell(storage_type)="row">
            <div class="text-muted">{{ get(row.item, 'metadata.storage_type') }}</div>
          </template>
          <template #cell(quantity)="row">
            {{ get(row.item, 'metadata.totalQty') }}
          </template>
          <template #cell(weight)="row">
            {{ get(row.item, 'metadata.totalGross') }}
          </template>
          <template #cell(volume)="row">
            {{ get(row.item, 'metadata.totalVolume') }}
          </template>
          <template #cell(area)="row">
            {{ getVehicleWorkingArea(row.item) }}
          </template>
          <template #cell(order)="row">
            <span
              class="order-count"
              @click="row.toggleDetails"
              :title="row.detailsShowing ? 'Hide Detail' : 'Show Detail'">
              <b>{{ row.item.orders.length }} Orders</b>
            </span>
          </template>
          <template #cell(action)="row">
            <b-button
              v-if="row.item.orders.length"
              @click="showMapModal('single', row.item)"
              title="Preview Route"
              class="px-2"
              pill
              variant="light">
              <i class="fa fa-map-pin"></i>
            </b-button>
          </template>
          <template #row-details="row">
            <b-card>
              <order-details-table
                @on-move-order="onClickIconMoveOrderDetail"
                @on-delete-order="onClickIconDeleteOrderDetail"
                :forceHideFieldAction="false"
                :tableData="prepareOrderDetail(row.item.orders, row.item)">
              </order-details-table>
              <b-button
                class="pull-right"
                @click="toggleOrderDetail(row)"
                variant="outline-warning"
                title="Close">
                Close
              </b-button>
            </b-card>
          </template>
        </b-table>
        <b-row>
          <b-col md="12">
          <b-pagination
            v-model="shipmentListTable.currentPage"
            :total-rows="shipmentListTable.totalRows"
            :per-page="shipmentListTable.perPage"
            align="center"
            class="my-0"
          ></b-pagination>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <b-overlay :show="snapshotSaving">
        <b-tabs id="order-extra-list" content-class="mt-3">
          <b-tab :title="`Unassigned (${unassignedOrder})`" active>
            <div v-if="unassignedOrderListByAreaArr.length > 0" class="card-columns">
              <shipment-box-item v-for="orderInArea in unassignedOrderListByAreaArr" :key="orderInArea.area"
                :shipment="orderInArea"
                @movedOrder="onMovedOrder"
                @fromOrder="fromOrder"
                @clickOrderInfo="onClickOrderInfo"
                @clickIconMove="onClickIconMove"
                @clickCreateLocation="onClickCreateOrderLocation"
                @requestSnapshot="captureSnapshot"
              />
            </div>
            <div v-else>
              <p>All orders are assigned (Filter applied).</p>
            </div>
          </b-tab>
          <b-tab :title="`Out of Area (${onCallOrder})`">
            <div v-if="onCallOrderListByGroups.length > 0" class="card-columns">
              <shipment-box-item v-for="(orderInGroup, groupIdx) in onCallOrderListByGroups" :key="`OOA-${orderInGroup.key}`"
                :shipment="orderInGroup"
                :startOrderNum="(groupIdx * 5)"
                @movedOrder="onMovedOrder"
                @fromOrder="fromOrder"
                @clickOrderInfo="onClickOrderInfo"
                @clickIconMove="onClickIconMove"
                @clickCreateLocation="onClickCreateOrderLocation"
                @requestSnapshot="captureSnapshot"
              />
            </div>
            <div v-else>
              <p>No out of area orders (Filter applied).</p>
            </div>
          </b-tab>
          <b-tab :title="`No Location (${invalidDestinationOrder})`">
            <div v-if="invalidDestinationOrderListByGroups.length > 0" class="card-columns">
              <shipment-box-item v-for="(orderInGroup, groupIdx) in invalidDestinationOrderListByGroups" :key="`NL-${orderInGroup.key}`"
                :shipment="orderInGroup"
                :startOrderNum="(groupIdx * 5)"
                @movedOrder="onMovedOrder"
                @fromOrder="fromOrder"
                @clickOrderInfo="onClickOrderInfo"
                @clickIconMove="onClickIconMove"
                @clickCreateLocation="onClickCreateOrderLocation"
                @requestSnapshot="captureSnapshot"
              />
            </div>
            <div v-else>
              <p>No orders with invalid location (Filter applied).</p>
            </div>
          </b-tab>
        </b-tabs>
        <div v-if="shipmentsNoJob.length" class="d-flex my-2">
          <h4>Without Job ({{ shipmentsNoJob.length }})</h4>
          <a class="px-4 my-1" v-if="shipmentNoJobShow" @click.prevent="shipmentNoJobShow = false" href="#">Hide <i class="fa fa-chevron-up"></i></a>
          <a class="px-4 my-1" v-else href="#" @click.prevent="shipmentNoJobShow = true">Show <i class="fa fa-chevron-down"></i></a>
        </div>
        <div v-if="shipmentsNoJob.length && shipmentNoJobShow" class="card-columns">
          <shipment-box-item v-for="shipment in shipmentsNoJob" :key="`NJ-${shipment.number}`"
            :shipment="shipment"
            @movedOrder="onMovedOrder"
            @fromOrder="fromOrder"
            @clickOrderInfo="onClickOrderInfo"
            @clickIconMove="onClickIconMove"
            @clickCreateLocation="onClickCreateOrderLocation"
            @requestSnapshot="captureSnapshot"
          />
        </div>
        <div v-if="shipmentsHasJobCreated.length" class="d-flex my-2">
          <h4>Has Deliveries ({{ shipmentsHasJobCreated.length }})</h4>
          <a class="px-4 my-1" v-if="shipmentCreatedShow" @click.prevent="shipmentCreatedShow = false" href="#">Hide <i class="fa fa-chevron-up"></i></a>
          <a class="px-4 my-1" v-else href="#" @click.prevent="shipmentCreatedShow = true">Show <i class="fa fa-chevron-down"></i></a>
        </div>
        <div v-if="shipmentsHasJobCreated.length && shipmentCreatedShow" class="card-columns">
          <shipment-box-item v-for="shipment in shipmentsHasJobCreated" :key="`CR-${shipment.number}`"
            :shipment="shipment"
            @movedOrder="onMovedOrder"
            @fromOrder="fromOrder"
            @clickOrderInfo="onClickOrderInfo"
            @clickIconMove="onClickIconMove"
            @clickCreateLocation="onClickCreateOrderLocation"
            @clickSwitchVehicle="onClickSwitchVehicle"
            @requestSnapshot="captureSnapshot"
            @showMapModal="showMapModal('single', shipment)"
          />
        </div>
        <div v-if="hasOrders" class="d-flex my-2">
          <h4>On Call Trucks ({{ shipmentsCreatedOnCall.length }})</h4>
          <a class="px-4 my-1" v-if="shipmentCreatedOnCallShow" @click.prevent="shipmentCreatedOnCallShow = false" href="#">Hide <i class="fa fa-chevron-up"></i></a>
          <a class="px-4 my-1" v-else href="#" @click.prevent="shipmentCreatedOnCallShow = true">Show <i class="fa fa-chevron-down"></i></a>
          <a class="px-4 my-1" href="#" @click.prevent="openModalOnCall">
            <i class="fa fa-plus-square"></i> {{addShipmentDummyLoading ? 'Loading...' : 'Add a truck'}}
          </a>
        </div>
        <div v-if="shipmentsCreatedOnCall.length && shipmentCreatedOnCallShow" class="card-columns">
          <shipment-box-item v-for="shipment in shipmentsCreatedOnCall" :key="`CRO-${shipment.number}`"
            :shipment="shipment"
            @movedOrder="onMovedOrder"
            @fromOrder="fromOrder"
            @clickOrderInfo="onClickOrderInfo"
            @clickIconMove="onClickIconMove"
            @clickCreateLocation="onClickCreateOrderLocation"
            @clickSwitchVehicle="onClickSwitchVehicle"
            @requestSnapshot="captureSnapshot"
            @showMapModal="showMapModal('single', shipment)"
          />
        </div>
        <div v-if="shipmentsHasJobReadyToLoad.length" class="d-flex my-2">
          <h4>Finished Routing ({{ shipmentsHasJobReadyToLoad.length }})</h4>
          <a class="px-4 my-1" v-if="shipmentReadyToLoadShow" @click.prevent="shipmentReadyToLoadShow = false" href="#">Hide <i class="fa fa-chevron-up"></i></a>
          <a class="px-4 my-1" v-else href="#" @click.prevent="shipmentReadyToLoadShow = true">Show <i class="fa fa-chevron-down"></i></a>
        </div>
        <div v-if="shipmentsHasJobReadyToLoad.length && shipmentReadyToLoadShow" class="card-columns">
          <shipment-box-item v-for="shipment in shipmentsHasJobReadyToLoad" :key="`RL-${shipment.number}`"
            :shipment="shipment"
            :initShowOrders="false"
            @movedOrder="onMovedOrder"
            @fromOrder="fromOrder"
            @clickOrderInfo="onClickOrderInfo"
            @clickIconMove="onClickIconMove"
            @clickCreateLocation="onClickCreateOrderLocation"
            @requestSnapshot="captureSnapshot"
            @showMapModal="showMapModal('single', shipment)"
          />
        </div>
        </b-overlay>
      </div>
    </b-card>
  </b-card>
  <b-alert show v-else-if="loaded">There's no order data.</b-alert>
  <sweet-modal title="Order Details" ref="openOrderDetails" width="75%">
    <order-details-table v-if="tableDetailOrderModal" :tableData="ordersDetail"></order-details-table>
    <b-button
      @click="closeModalOrderDetail"
      variant="outline-secondary"
      class="pull-right">Close
    </b-button>
  </sweet-modal>
  <sweet-modal blocking :title="`Move this order (<strong>${get(targetMoveOrder, 'number')}</strong>)`" @close="onClosedModalMove" @open="onOpenedModalMove" ref="modalAssign" width="50%">
    <div class="row">
      <div class="col-md-12">
        <b-form-input
          @input="onSearchShipmentMove"
          v-model="searchShipmentValue"
          class="mb-2"
          type="text" placeholder="Search shipment"></b-form-input>
        <div v-if="shipmentListMoveOrder.length !== 0" style="text-align: left;" class="target-shipment-list-container">
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="targetShipmentIdMove"
              :options="shipmentListMoveOrder"
              :aria-describedby="ariaDescribedby"
              name="radio-target-shipment"
              stacked
            >
            </b-form-radio-group>
          </b-form-group>
        </div>
        <div v-else>
          <p class="text-warning" style="text-align: center;"><b>No available shipments</b></p>
        </div>
      </div>
    </div>
    <hr>
    <b-button
      @click="startMoveOrder"
      :disabled="emptyTargetShipmentMove"
      class="pull-left"
      variant="primary">{{ textButtonMove }}</b-button>
    <b-button
      @click="closeModalMoveOrder"
      variant="outline-secondary"
      class="pull-right">Cancel</b-button>
  </sweet-modal>
  <sweet-modal hide-close-button blocking ref="modalLoading" width="50%">
    {{ stateLoadText }}
  </sweet-modal>
  <sweet-modal
    blocking
    :title="`Switch Vehicle for Shipment (<strong>${get(sourceShipmentSwitch, 'number')}</strong>)`"
    @close="onClosedModalSwitch"
    @open="onOpenedModalSwitch"
    ref="modalSwitch"
    width="50%"
  >
    <div class="row">
      <div class="col-md-12">
        <b-form-input
          @input="onSearchShipmentSwitch"
          v-model="searchShipmentSwitchValue"
          class="mb-2"
          type="text" placeholder="Search Shipment"></b-form-input>
        <div style="text-align: left;" class="target-shipment-list-container">
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              v-model="targetShipmentSwitchId"
              :options="shipmentSwitchList"
              :aria-describedby="ariaDescribedby"
              name="radio-target-shipment"
              stacked
            >
            </b-form-radio-group>
          </b-form-group>
        </div>
      </div>
    </div>
    <hr>
    <b-button
      @click="startSwitchShipment"
      :disabled="emptyTargetShipmentSwitch"
      class="pull-left"
      variant="primary">{{ textButtonSwitch }}</b-button>
    <b-button
      @click="closeModalSwitch"
      variant="outline-secondary"
      class="pull-right">Cancel</b-button>
  </sweet-modal>
  <sweet-modal blocking @close="onCloseModalFixDestination" :title="`Fix Order Destination (<b>${get(orderFixDestination, 'number')}</b>)`" ref="modalFixDestination" width="50%">
    <div class="location-form-container">
      <b-form class="fix-location-form" @submit.prevent="onSubmitFixDestination()">
        <div v-if="destinationsListOrder.length !== 0" class="setup-check-ava-locations">
          <b-form-checkbox
            v-model="replaceAvailableLocationsCheckbox"
            name="available-locations-check"
            value="yes-replace"
            unchecked-value="no-create-new"
          > Update Existing Location </b-form-checkbox>
        </div>
        <div v-if="isReplaceAvailableLocations" style="text-align: left;" class="available-location-container">
          <b-form-group label="Available Locations">
            <b-form-radio-group
              v-validate="'required'"
              :class="{'is-invalid': errors.has('target-location')}"
              v-model="destinationSelectedOrder"
              :options="destinationsListOrder"
              name="target-location"
              stacked
            >
            </b-form-radio-group>
            <b-form-feedback>{{ errors.first('target-location') }}</b-form-feedback>
          </b-form-group>
        </div>
        <hr>
        <div class="form-input-lonlat">
          <div class="form-row col-md-12">
            <label>Location Code</label>
            <b-form-input
              name="code"
              v-validate="'required'"
              :class="{'is-invalid': errors.has('code')}"
              :disabled="isReplaceAvailableLocations"
              v-model="fixDestinationForm.locationCode"
              class="mb-2"
              type="text" placeholder="Location Code"></b-form-input>
            <b-form-feedback>{{ errors.first('code') }}</b-form-feedback>
          </div>
          <div class="form-row col-md-12">
            <label>Name</label>
            <b-form-input
              name="name"
              v-validate="'required'"
              :class="{'is-invalid': errors.has('name')}"
              :disabled="isReplaceAvailableLocations"
              v-model="fixDestinationForm.name"
              class="mb-2"
              type="text" placeholder="Name"></b-form-input>
            <b-form-feedback>{{ errors.first('name') }}</b-form-feedback>
          </div>
          <div class="form-row col-md-12">
            <label>Latitude</label>
            <b-form-input
              name="latitude"
              v-validate="'required'"
              :class="{'is-invalid': errors.has('latitude')}"
              v-model="fixDestinationForm.latitude"
              class="mb-2"
              type="text" placeholder="Exp. -4.12027403932379"></b-form-input>
            <b-form-feedback>{{ errors.first('latitude') }}</b-form-feedback>
          </div>
          <div class="form-row col-md-12">
            <label>Longitude</label>
            <b-form-input
              name="longitude"
              v-validate="'required'"
              :class="{'is-invalid': errors.has('longitude')}"
              v-model="fixDestinationForm.longitude"
              class="mb-2"
              type="text" placeholder="Exp. 24.5102593302727"></b-form-input>
            <b-form-feedback>{{ errors.first('longitude') }}</b-form-feedback>
          </div>
        </div>
        <div class="footer-form">
          <hr>
          <b-button
            type="submit"
            class="pull-left"
            variant="primary">{{ textButtonFixDestination }}</b-button>
        </div>
      </b-form>
    </div>
  </sweet-modal>
  <sweet-modal
    blocking
    title="Change Delivery Date"
    ref="modalChange"
    width="50%"
  >
    <div class="row">
      <div class="col-md-12">
        <b-calendar
          block
          locale="id"
          v-model="selectedChangeDeliveryDate"
          :min="tommorowDate"/>
      </div>
    </div>
    <hr>
    <b-button
      @click="startChangeDelivery"
      class="pull-left"
      variant="primary">{{ textButtonChangeDeliveryDate }}</b-button>
    <b-button
      @click="closeModalChange"
      variant="outline-secondary"
      class="pull-right">Cancel</b-button>
  </sweet-modal>
  <sweet-modal
    blocking
    title="Add On Call Truck"
    ref="modalOnCall"
    width="50%"
  >
    <div class="row">
      <div class="col-md-12">
        <b-form>
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="plate_no">Reg Number</label>
              <b-form-input
                name="reg number"
                v-validate="'required'"
                :class="{'is-invalid': errors.has('reg number')}"
                v-model="onCallTruck.plate_no"
                class="mb-2"
                type="text" placeholder="Truck"></b-form-input>
              <b-form-feedback>{{ errors.first('reg number') }}</b-form-feedback>
            </div>
            <div class="form-group col-md-6">
              <label for="type_full">Storage Type</label>
              <b-form-select
                name="storage type"
                v-validate="'required'"
                v-model="onCallTruck.type_full"
                :options="storageTypeOptions"
                :class="{'is-invalid': errors.has('storage type')}">
              </b-form-select>
              <b-form-feedback>{{ errors.first('storage type') }}</b-form-feedback>
            </div>
            <div class="form-group col-md-6">
              <label for="max_weight">Max Weight</label>
              <b-form-input
                name="max weight"
                v-validate="'required'"
                :class="{'is-invalid': errors.has('max weight')}"
                v-model="onCallTruck.max_weight"
                class="mb-2"
                min="0"
                type="number" placeholder="Truck"></b-form-input>
              <b-form-feedback>{{ errors.first('max weight') }}</b-form-feedback>
            </div>
            <div class="form-group col-md-6">
              <label for="max_volume">Max Volume</label>
              <b-form-input
                name="max volume"
                v-validate="'required'"
                :class="{'is-invalid': errors.has('max volume')}"
                v-model="onCallTruck.max_volume"
                class="mb-2"
                min="0"
                type="number" placeholder="Truck"></b-form-input>
              <b-form-feedback>{{ errors.first('max volume') }}</b-form-feedback>
            </div>
          </div>
        </b-form>
      </div>
    </div>
    <hr>
    <b-button
      @click="addDummyShipment"
      :disabled="isCreateOnCallDisabled"
      class="pull-left"
      variant="primary">{{ textButtonOnCall }}</b-button>
    <b-button
      @click="closeModalOnCall"
      variant="outline-secondary"
      class="pull-right">Cancel</b-button>
  </sweet-modal>
  <add-order-form
    @on-submited-data="onSubmitedOrderForm"
    @on-closed-modal="onOrderFormClose"
    @on-opened-modal="onFormShow"
    :deliveryDate="selectedDate"
    :shipmentsData="shipments"
    :customersData="customersData"
    :formState="orderFormState"
    :isVisible="orderFormVisible"></add-order-form>
  <MapPopupRoute
    @on-opened-modal="onMapShow"
    @on-closed-modal="onMapHide"
    :lineCollections="lineCollections"
    :markerPoints="markerCollections"
    :title="mapTitle"
    :mapState="mapState"
    :tableShipment="listTableMap"
    :isVisible="mapVisible"/>
  </div>
</template>
<script>
/* eslint-disable */
import dateMixin from '@/mixins/date';
import {
  throttle, last, uniqBy, concat, isEmpty,
  get, filter, isEqual, isObject, omit,
  isString, cloneDeep, head, sumBy, debounce,
  orderBy, trim, intersection, round,
  groupBy, findIndex
} from 'lodash';
import { format } from 'date-fns';
import localforage from 'localforage';
import moment from 'moment';

import tmsApi from '@/api/tmsApi';
import Multiselect from 'vue-multiselect';
import UiMultiselect from '@/components/UiMultiselect';
import MapPopupRoute from '@/components/MapPopupRoute';
import OrderDetailsTable from '@/components/OrderDetailsTable';
import AddOrderForm from '@/components/AddOrderForm';
import ShipmentBoxItem from '../../../../components/shipment_md/ShipmentBoxItem.vue';
import DatePicker from 'vue2-datepicker';

export default {
  name: 'order_list',
  mixins: [dateMixin],
  components: {
    Multiselect,
    UiMultiselect,
    MapPopupRoute,
    OrderDetailsTable,
    AddOrderForm,
    ShipmentBoxItem,
    DatePicker,
  },
  data() {
    const tomorrow = new Date(Date.now() + (24 * 3600 * 1000));
    return {
      tommorowDate: tomorrow,
      selectedDate: tomorrow,
      orderFormVisible: false,
      orderFormState: 'loading',
      mapVisible: false,
      mapState: 'loading',
      showRouteType: 'all',
      mapTitle: 'All Routes',
      shipments: [],
      storageColors: {
        DRY: '#FFF2CC',
        CHILLER: '#F8CECC',
        FROZEN: '#DAE8FC',
      },
      editable: true,
      isDragging: false,
      delayedDragging: false,
      companiesData: [],
      customersData: [],
      loaded: false,
      searchQuery: '',
      filterType: 'ACTIVE',
      lastData: null,
      lastDataAr: [],
      destinationList: [],
      selectedCompany: null,
      initSelectCompany: null,
      selectedCustomer: null,
      initSelectCustomer: null,
      selectedDestination: null,
      initSelectDestination: null,
      currentSort: null,
      initSelectSort: null,
      sortOptions: [
        { id: 1, value: 'NUMBER.ASC', name: 'Number 0-9' },
        { id: 2, value: 'NUMBER.DESC', name: 'Number 9-0' },
        { id: 3, value: 'ID.DESC', name: 'Last Created' },
        { id: 4, value: 'ID.ASC', name: 'Oldest Created' },
      ],
      table: {
        fields: [
          {
            key: 'number',
            sortable: true
          },
          {
            key: 'customer',
            sortable: false
          },
          {
            key: 'metadata',
            label: 'Storage Type',
            sortable: false
          },
          {
            key: 'action',
            label: 'Action',
            sortable: false
          },
        ],
        items: [],
      },
      shipmentListTable: {
        perPage: 10,
        totalRows: 0,
        currentPage: 1,
        pageOptions: [10, 15, 20, { value: 100, text: "Show a lot" }],
        filter: null,
        fields: [
          {
            key: 'index',
            label: '#',
          },
          {
            key: 'number',
            label: 'Number',
            sortable: true,
          },
          {
            key: 'driver',
            label: 'Driver',
            sortable: true,
          },
          {
            key: 'vehicle',
            label: 'Vehicle',
            sortable: true,
          },
          {
            key: 'distance',
            label: 'Distance',
            sortable: false,
          },
          {
            key: 'duration',
            label: 'Duration',
            sortable: false,
          },
          {
            key: 'storage_type',
            label: 'Storage Type',
            sortable: false,
          },
          {
            key: 'quantity',
            label: 'Quantity',
            sortable: false,
          },
          {
            key: 'weight',
            label: 'Weight',
            sortable: false,
          },
          {
            key: 'volume',
            label: 'Volume',
            sortable: false,
          },
          {
            key: 'area',
            label: 'Area',
            sortable: false,
          },
          {
            key: 'order',
            label: 'Orders',
          },
          {
            key: 'action',
            label: 'Action',
          },
        ],
        items: [],
      },
      fromShipment: '',
      toShipment: '',
      sortType: null,
      files: null,
      uploadProcessed: false,
      isUploadError: false,
      isStillUpload: false,
      fileUpload: null,
      fileUploadCreateShipment: false,
      uploadResult: false,
      uploadResultText: '',
      uploadText: 'Start Upload',
      errorResultText: {},
      lineCollections: [],
      markerCollections: [],
      vehicleLineColors: {},
      shipmentListMoveOrder: [],
      listTableMap: {},
      sourceShipmentMove: null,
      targetShipmentIdMove: null,
      targetMoveOrder: null,
      textButtonMove: 'Move',
      searchShipmentValue: '',
      shipmentSwitchList: [],
      sourceShipmentSwitch: null,
      targetShipmentSwitchId: null,
      textButtonSwitch: 'Switch',
      searchShipmentSwitchValue: '',
      stateLoadText: '',
      moveTypeAction: 'move',
      shipmentShowRoute: null,
      showRouteType: null,
      orderFixDestination: null,
      textButtonFixDestination: 'Submit',
      fixDestinationForm: {
        locationCode: '-',
        name: '',
        latitude: '',
        longitude: '',
      },
      destinationSelectedOrder: null,
      destinationsListOrder: [],
      locationData: [],
      isReplaceAvailableLocations: false,
      replaceAvailableLocationsCheckbox: 'no-create-new',
      ordersDetail: [],
      shipmentListViewMode: false,
      listViewModeKey: 'list-view-mode',
      alertExportedShipment: false,
      resultExportedShipment: false,
      linkFileExportShipment: '#',
      tableDetailOrderModal: false,
      routingSummaryLoading: false,
      routing_summary: [],
      storageSelected: [],
      storageList: [
        'DRY',
        'CHILLER',
        'COMBINE',
      ],
      areaSelected: [],
      areaList: [
        'BEKASI CAKUNG',
        'BEKASI CIKARANG',
        'BEKASI NAROGONG',
        'BEKASI SUMMARECON',
        'BOGOR',
        'DEPOK',
        'JAKARTA BARAT CENGKARENG',
        'JAKARTA BARAT KEBON JERUK',
        'JAKARTA PUSAT',
        'JAKARTA SELATAN CILANDAK',
        'JAKARTA SELATAN KUNINGAN',
        'JAKARTA SELATAN PONDOK INDAH',
        'JAKARTA TIMUR',
        'JAKARTA UTARA KAPUK',
        'JAKARTA UTARA KELAPA GADING',
        'TANGERANG SELATAN',
        'TANGERANG KOTA',
        'SERANG',
      ],
      shipmentNoJobShow: true,
      shipmentCreatedShow: true,
      shipmentCreatedOnCallShow: true,
      shipmentReadyToLoadShow: true,
      snapshotTimer: 0,
      loadShipmentTimer: 0,
      snapshotSaving: false,
      addShipmentDummyLoading: false,
      selectedChangeDeliveryDate: tomorrow,
      textButtonChangeDeliveryDate: 'Change',
      onCallTruck: {
        type_full: null,
        plate_no: '',
        max_volume: 0,
        max_weight: 0,
      },
      storageTypeOptions: [
        { value: null, text: 'Please Select Storage Type' },
        { value: 'CDE Chiller', text: 'CDE Chiller' },
        { value: 'CDE Chiller Combine', text: 'CDE Chiller Combine' },
        { value: 'CDE Dry', text: 'CDE Dry' },
        { value: 'L300 Dry', text: 'L300 Dry' },
        { value: 'CDD Dry', text: 'CDD Dry' },
      ],
      textButtonOnCall: 'Create',
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'shipment_md', name: 'Shipment MD' },
      { to: 'orders', name: 'Orders' },
      { to: 'routing', name: 'Routing' },
    ]);
    this.$store.commit('shipment_md/orders/CLEAR_QUERY');
    this.$store.dispatch('shipment_md/orders/LOAD_LOCATIONS').then(() => {
      this.destinationList = this.locations;
    });
    this.loadTodayOrders();
    this.loadShipments();
    this.initFromUrl();
    this.getViewMode();
  },
  computed: {
    shipmentFiltered() {
      let allShipments = this.shipments;
      if (this.areaSelected.length > 0) {
        allShipments = allShipments.filter((shipment) => {
          const workingArea = get(shipment, 'vehicle.metadata.working_area', []);
          const isAll = workingArea[0] === 'ALL';
          if (isAll) return true;
          return intersection(this.areaSelected.map(a => a.toLowerCase()),
            workingArea.map(a => a.toLowerCase())).length > 0;
        });
      }
      if (this.storageSelected.length > 0) {
        allShipments = allShipments.filter((shipment) => {
          const type = get(shipment, 'metadata.storage_type', '');
          return this.storageSelected.indexOf(type) > -1;
        });
      }

      return allShipments;
    },
    shipmentsHasJob() {
      return this.shipmentFiltered
        .filter(shipment => shipment.orders.length > 0);
    },
    shipmentsHasJobCreated() {
      return this.shipmentsHasJob
        .filter(s => s.state === 'CREATED')
        .filter(s => s.vehicle);
    },
    shipmentsHasJobCreatedOnCall() {
      return this.shipmentsHasJob
        .filter(s => s.state === 'CREATED')
        .filter(s => !s.vehicle);
    },
    shipmentsCreatedOnCall() {
      return this.shipmentFiltered
        .filter(s => s.state === 'CREATED')
        .filter(s => !s.vehicle);
    },
    shipmentsHasJobReadyToLoad() {
      return this.shipmentsHasJob.filter(s => s.state === 'READY_TO_LOAD');
    },
    shipmentsNoJob() {
      return this.shipmentFiltered
        .filter(shipment => shipment.vehicle)
        .filter(shipment => shipment.orders.length === 0);
    },
    dragOptions() {
      return {
        animation: 0,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost',
      };
    },
    token() {
      return this.$store.getters.token;
    },
    locations() {
      return this.$store.getters['shipment_md/orders/get_locations_data'];
    },
    orders() {
      return this.$store.getters['shipment_md/orders/orders'];
    },
    get_routing() {
      return this.$store.getters['shipment_md/orders/get_order_route'];
    },
    isNotEmpty() {
      return true;
    },
    prevDisabled() {
      return this.lastData === null;
    },
    nextDisabled() {
      return this.orders.length < 10;
    },
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
    myCompany() {
      const { userData } = this.$store.getters;
      return userData.company_id;
    },
    isFiltered() {
      const filtered =
        !isEmpty(this.selectedCompany) ||
        !isEmpty(this.selectedCustomer) ||
        !isEmpty(this.selectedDestination) ||
        !isEmpty(this.currentSort);
      return filtered;
    },
    hasSelectedCustomer() {
      return !this.selectedCustomer || isEmpty(this.destinationList);
    },
    ordersGetters() {
      return this.$store.getters['shipment_md/orders/dataOrders'];
    },
    isLoading() {
      return this.ordersGetters === 'LOADING';
    },
    isFetched() {
      return this.ordersGetters === 'LOADED';
    },
    noFileUploadChosen() {
      return this.fileUpload == null || this.selectedCustomer === '' || this.isStillUpload;
    },
    uploadAlert() {
      return this.uploadResult ? 'success' : 'danger';
    },
    availableShipmentData() {
      return !isEmpty(this.shipments);
    },
    availableOrderData() {
      return !isEmpty(this.orders);
    },
    emptyTargetShipmentMove() {
      return isEmpty(this.targetShipmentIdMove);
    },
    emptyTargetShipmentSwitch() {
      return isEmpty(this.targetShipmentSwitchId);
    },
    invalidDestinationOrder() {
      const invalidDestination = this.routing_summary.find(r => r.type == 'invalid_dest');
      return get(invalidDestination, 'count', 0);
    },
    hasOrders() {
      return Object.keys(this.routing_summary)
        .map(k => this.routing_summary[k].orders || [])
        .filter(o => o.length > 0)
        .length > 0;
    },
    hasOrdersNotAssigned() {
      return Object.keys(this.routing_summary)
        .filter(k => this.routing_summary[k].type !== 'assigned')
        .map(k => this.routing_summary[k].orders || [])
        .filter(o => o.length > 0)
        .length > 0;
    },
    canRestart() {
      const assignedOrders = this.routing_summary.find(s => s.type === 'assigned');
      const finishedOrders = assignedOrders.orders.filter(o => o.shipment.state !== 'CREATED' && o.shipment.state !== 'READY_TO_LOAD');
      return finishedOrders.length === 0
    },
    onCallOrder() {
      const onCall = this.routing_summary.find(r => r.type == 'on_call');
      return get(onCall, 'count', 0);
    },
    unassignedOrder() {
      const unassigned = this.routing_summary.find(r => r.type == 'unassigned');
      return get(unassigned, 'count', 0);
    },
    assignedOrder() {
      const assigned = this.routing_summary.find(r => r.type == 'assigned');
      return get(assigned, 'count', 0);
    },
    totalOrdersPL() {
      let total = 0;
      Object.values(this.routing_summary).forEach((dt) => {
        const { count } = dt;
        total += count;
      });
      return total;
    },
    invalidDestinationOrderList() {
      const invalidDestination = this.routing_summary.find(r => r.type == 'invalid_dest');
      return get(invalidDestination, 'orders', []).filter((order) => {
        if (this.storageSelected.length === 0) return true;
        const trType = get(order, 'metadata.truck_type');
        if (this.storageSelected.indexOf('COMBINE') > -1) {
          return true;
        }
        if (trType === 'DRY') {
          return this.storageSelected.indexOf('DRY') > -1;
        }
        return this.storageSelected.indexOf('CHILLER') > -1;
      });
    },
    invalidDestinationOrderListPart() {
      return this.invalidDestinationOrderList.reduce((total, order) => {
        const pushValue = (idx) => {
          if (total[idx] === undefined) total[idx] = [];
          if (total[idx].length >= 5) {
            return pushValue(idx + 1);
          }
          total[idx].push(order);
        };
        pushValue(0);
        return total;
      }, []);
    },
    invalidDestinationOrderListByGroups() {
      return Object.keys(this.invalidDestinationOrderListPart)
        .map((key) => ({ id: `UO-${key}`, key: `ID:${key}`, orders: this.invalidDestinationOrderListPart[key]}));
    },
    onCallOrderList() {
      const onCall = this.routing_summary.find(r => r.type == 'on_call');
      return get(onCall, 'orders', []).filter((order) => {
        if (this.storageSelected.length === 0) return true;
        const trType = get(order, 'metadata.truck_type');
        if (this.storageSelected.indexOf('COMBINE') > -1) {
          return true;
        }
        if (trType === 'DRY') {
          return this.storageSelected.indexOf('DRY') > -1;
        }
        return this.storageSelected.indexOf('CHILLER') > -1;
      });;
    },
    onCallOrderListPart() {
      return this.onCallOrderList.reduce((total, order) => {
        const pushValue = (idx) => {
          if (total[idx] === undefined) total[idx] = [];
          if (total[idx].length >= 5) {
            return pushValue(idx + 1);
          }
          total[idx].push(order);
        };
        pushValue(0);
        return total;
      }, []);
    },
    onCallOrderListByGroups() {
      return Object.keys(this.onCallOrderListPart)
        .map((key) => ({ id: `UO-${key}`, key: `OC:${key}`, orders: this.onCallOrderListPart[key]}));
    },
    unassignedOrderList() {
      const unassigned = this.routing_summary.find(r => r.type == 'unassigned');
      return get(unassigned, 'orders', []).filter((order) => {
        if (this.storageSelected.length === 0) return true;
        const trType = get(order, 'metadata.truck_type');
        if (this.storageSelected.indexOf('COMBINE') > -1) {
          return true;
        }
        if (trType === 'DRY') {
          return this.storageSelected.indexOf('DRY') > -1;
        }
        return this.storageSelected.indexOf('CHILLER') > -1;
      });
    },
    unassignedOrderListByArea() {
      return groupBy(this.unassignedOrderList, (order) => {
        const city = get(order, 'metadata.skill_area');
        if (city) return city;
        return get(order, 'metadata.customer_city', 'UNKNOWN').toUpperCase();
      });
    },
    unassignedOrderListByAreaArr() {
      return Object.keys(this.unassignedOrderListByArea)
        .map((area) => ({ id: `UO-${area}`, area, number: area, orders: this.unassignedOrderListByArea[area]}))
        .filter((list) => this.areaSelected.length === 0 ? true : this.areaSelected.indexOf(list.area) > -1 );
    },
    shipmentDateHuman() {
      return moment(this.selectedDate).format('dddd, D MMM YYYY');
    },
    onCallShipments() {
      return this.shipments.filter(shipment => get(shipment, 'metadata.truck_on_call_info', false));
    },
    isCreateOnCallDisabled() {
      return !this.onCallTruck.plate_no
      || !this.onCallTruck.type_full
      || (this.onCallTruck.max_volume === 0 || this.onCallTruck.max_volume === "0")
      || (this.onCallTruck.max_weight === 0 || this.onCallTruck.max_weight === "0");
    },
    isTunas() {
      const namespace = this.get(this.$store.getters, 'userData.company.namespace');
      return namespace === 'PRAMBANAN';
    },
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
    searchQuery(newValue) {
      this.updateSearchQuery(this, newValue);
    },
    orders(data) {
      this.table.items.splice(0);
      data.forEach((d) => {
        this.table.items.push(d);
      });
    },
    get_routing(data) {
    },
    replaceAvailableLocationsCheckbox(value) {
      const isReplace = value === 'yes-replace'
      this.isReplaceAvailableLocations = isReplace;

      if (isReplace) {
        this.fixDestinationForm.locationCode = '';
      } else {
        const externalId = this.get(this.orderFixDestination, 'customer.external_id') || '';
        this.fixDestinationForm.locationCode = externalId ? externalId.replace('PRB-', '') : '-';
        this.destinationSelectedOrder = null;
      }
      this.fixDestinationForm.name = '-';
    },
    destinationSelectedOrder(locationId) {
      const selectedLocation = this.locationData.find(dt => (dt.id === locationId));
      this.fixDestinationForm.locationCode = selectedLocation.code ? selectedLocation.code.replace('PRB-', '') : '-' ;
      this.fixDestinationForm.name = selectedLocation.name;
    },
    shipmentListViewMode(enable) {
      localforage.setItem(this.listViewModeKey, enable);
    },
  },
  methods: {
    get(object, key) {
      return get(object, key) || '-';
    },
    dateFormat(date, formatString = 'YYYY-MM-DD') {
      return format(date, formatString);
    },
    roundNum(num, t) {
      return round(num, t);
    },
    getLocationsByCompanyId(id) {
      return this.$store.dispatch('shipment_md/locations/GET_LOCATIONS_BY_COMPANYID', { company_id: id });
    },
    checkCustomerIsMyCompany(order) {
      const { customer, company } = order;
      return customer.id === company.id;
    },
    getViewMode() {
      return localforage.getItem(this.listViewModeKey).then((isActiveListMode) => {
        if (isActiveListMode) {
          this.shipmentListViewMode = isActiveListMode;
        } else {
          this.shipmentListViewMode = false;
        }
      });
    },
    onConfirmDate() {
      this.routingSummaryLoading = true;
      setTimeout(() => {
        this.loadShipments();
      }, 5e2);
    },
    addOrder() {
      this.orderFormVisible = true;
    },
    getVehicleWorkingArea(data) {
      const workingArea = get(data, 'vehicle.metadata.working_area') || [];
      return workingArea.join(', ') || '-';
    },
    onClickInvalidDestination(order) {
      const { id: customerId } = order.customer;
      const externalId = this.get(order, 'customer.external_id') || '';
      this.fixDestinationForm.locationCode = externalId ? externalId.replace('PRB-', '') : '';
      this.orderFixDestination = order;

      this.setStateModalLoading(true, 'Checking available locations...');
      this.getLocationsByCompanyId(customerId).then((locations) => {
        if (locations.length) {
          const locationOptions = locations.map(dt => ({ text: dt.name, value: dt.id }));
          this.locationData = locations;
          this.destinationsListOrder = orderBy(locationOptions, ['text'], ['asc']);
        } else {
          this.destinationsListOrder = [];
        }

        setTimeout(() => {
          this.setStateModalLoading(false);
          this.$refs.modalFixDestination.open();
        }, 1e3);
      });
    },
    onSubmitFixDestination() {
      this.validateFixDestinationForm().then((valid) => {
        if (valid) {
          const orderId = this.get(this.orderFixDestination, 'id');
          const customerId = this.get(this.orderFixDestination, 'customer.id');
          const { locationCode: code, longitude, latitude, name } = this.fixDestinationForm;
          const payloads = {
            code,
            name,
            longitude: parseFloat(longitude),
            latitude: parseFloat(latitude),
            type: 1,
            metadata: {
              radius: 50,
            },
            geometry: {
              type: 'Point',
              coordinates: [parseFloat(latitude), parseFloat(longitude)],
            },
            company_id: customerId,
          };

          if (this.isReplaceAvailableLocations) {
            payloads.id = this.destinationSelectedOrder;
          }

          this.textButtonFixDestination = 'Processing...';
          this.createUpdateLocation(payloads).then((resp) => {
            const { id: newLocationId } = resp;
            this.assignOrderDestination(orderId, newLocationId).then(() => {
              this.textButtonFixDestination = 'Success';
              setTimeout(() => {
                this.textButtonFixDestination = 'Submit';
                this.resetFixDestinationForm();
                this.$refs.modalFixDestination.close();
                this.loadTodayOrders();
                this.loadShipments();
              }, 1e3);
            });
          })
        } else {
          const errorFields = this.$validator.errors.items.map(dt => dt.field);
          if (errorFields.includes('target-location')) {
            document.querySelector('.available-location-container').scrollBy(0, 150);
          }
        }
      });
    },
    validateFixDestinationForm() {
      const itemCheck = [
        this.$validator.validate('code'),
        this.$validator.validate('name'),
        this.$validator.validate('latitude'),
        this.$validator.validate('longitude'),
      ];

      if (this.isReplaceAvailableLocations) {
        itemCheck.push(this.$validator.validate('target-location'));
      }

      return Promise.all(itemCheck).then(validArray => !validArray.includes(false));
    },
    resetFixDestinationForm() {
      this.fixDestinationForm.locationCode = '';
      this.fixDestinationForm.name = '';
      this.fixDestinationForm.longitude = '';
      this.fixDestinationForm.latitude = '';
    },
    createUpdateLocation(payloads) {
      const isUpdate = payloads.hasOwnProperty('id');
      const action = isUpdate ? 'UPDATE_DATA' : 'CREATE_DATA';
      return this.$store.dispatch(`shipment_md/locations/${action}`, payloads);
    },
    assignOrderDestination(orderId, locationId) {
      return this.$store.dispatch('shipment_md/orders/UPDATE_DATA', {
        id: orderId,
        destination: {
          id: locationId,
        },
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    onCloseModalFixDestination() {
      this.replaceAvailableLocationsCheckbox = 'no-create-new';
      this.destinationSelectedOrder = null;
    },
    formatDistance(shipment) {
      const distanceOnMeter = this.get(shipment, 'metadata.route.distance') || null;
      const distanceOnKm = distanceOnMeter / 1000;

      if (!distanceOnMeter || isNaN(distanceOnKm)) return '';

      return `${distanceOnKm} Km`;
    },
    formatDuration(shipment) {
      const oneHourOnSeconds = 3600;
      const durationOnSeconds = this.get(shipment, 'metadata.route.duration') || null;
      const leftOnSeconds = durationOnSeconds % oneHourOnSeconds;
      const durationOnHour = Math.round((durationOnSeconds - leftOnSeconds) / 60 / 60);
      const leftOnMinutes = Math.round(leftOnSeconds / 60);

      if (!durationOnSeconds || isNaN(leftOnMinutes)) return '';

      return durationOnHour ? `${durationOnHour}h ${leftOnMinutes}m` : `${leftOnMinutes}m`;
    },
    onMapShow() {
      this.mapState = 'loading';

      const shipmentIds = this.showRouteType === 'single'
        ? [this.shipmentShowRoute.id]
        : this.shipments.map(dt => dt.id);

      this.$store.dispatch('shipment_md/shipments/LOAD_SHIPMENT_SUMMARIES', {
        shipment_ids: shipmentIds,
      }).then((summaries) => {
        const data = Object.values(summaries);
        this.mapState = 'ready';

        if (!isEmpty(data)) {
          this.vehicleLineColors = this.generateLineColor(data);
          this.lineCollections = this.getLineCollections(data);
          this.markerCollections = this.getMarkerCollections(data);
          this.listTableMap = data[0];
        }
      });

      // setTimeout(() => {
      //   const data = this.showRouteType === 'single' ? [this.shipmentShowRoute] : this.shipments;

      //   this.mapState = 'ready';
      //   this.vehicleLineColors = this.generateLineColor(data);
      //   this.lineCollections = this.getLineCollections(data);
      //   this.markerCollections = this.getMarkerCollections(data);
      // }, 2e3);
    },
    onMapHide() {
      this.mapVisible = false;
      this.mapState = 'idle';
    },
    onFormShow() {
      this.orderFormState = 'loading';
      this.loadCompaniesData().then(() => {
        this.orderFormState = 'ready';
      });
    },
    onOrderFormClose() {
      this.orderFormVisible = false;
      this.orderFormState = 'loading';
    },
    onSubmitedOrderForm() {
      this.loadTodayOrders();
      this.loadShipments();
    },
    showMapModal(type, shipment = null) {
      this.shipmentShowRoute = shipment;
      // this.listTableMap = shipment;
      this.showRouteType = type;
      this.mapTitle = type === 'single' && shipment ? `Shipment Route (${shipment.number})` : 'All Routes';
      this.mapVisible = true;
    },
    initFromUrl() {
      const { query } = this.$route;

      if (isString(query.company_id) && query.company_id !== undefined) {
        this.onSelectCompany(query.company_id, true);
      }

      if (isString(query.customer_id) && query.customer_id !== undefined) {
        this.onSelectCustomer(query.customer_id, true);
      }

      if (isString(query.destination_id) && query.destination_id !== undefined) {
        this.onSelectDestination(query.destination_id, true);
      }

      if (query.sort !== undefined) {
        this.onSelectSort(query.sort, true);
      }

      this.loadData();
    },
    resetPagination() {
      this.lastData = null;
      this.lastDataAr = [];
    },
    updateSearchQuery: throttle((context, searchTerm) => {
      const searchQuery = searchTerm.trim();
      context.resetPagination();
      context.$store.commit('shipment_md/orders/SET_QUERY_SEARCH', searchQuery);
      context.loadData();
    }, 500, {
      leading: false,
    }),
    getConfirmation(data) {
      return data.confirmations.find(c => c.key === 'customer') || {};
    },
    loadData() {
      this.$store.commit('shipment_md/orders/SET_QUERY_LAST_DATA', this.lastData);
      if (this.searchQuery.trim() !== '') {
        return this.$store.dispatch('shipment_md/orders/FIND_DATA');
      }
      return this.loadTodayOrders();
    },
    prevPage() {
      this.lastDataAr.pop();
      if (this.lastDataAr.length) {
        this.lastData = last(this.lastDataAr);
      } else {
        this.lastData = null;
      }
      this.loadData();
    },
    nextPage() {
      const currSort = isEmpty(this.currentSort) ? '' : this.currentSort;
      const sortBy = head(currSort.split('.'));
      let lastDataKey = isEmpty(sortBy) ? 'id' : sortBy.toLowerCase();
      const skipBy = isEmpty(sortBy) ? 'ID' : sortBy;

      if (this.searchQuery.trim() !== '') {
        lastDataKey = 'number';
        this.$store.commit('shipment_md/orders/SET_SKIP_BY', 'NUMBER');
        this.$store.commit('shipment_md/orders/SET_QUERY_SORT', 'NUMBER.ASC');
      } else {
        this.$store.commit('shipment_md/orders/SET_SKIP_BY', skipBy);
      }

      const order = last(this.orders);
      this.lastDataAr.push(order[lastDataKey]);
      this.lastData = order[lastDataKey];
      this.loadData();
    },
    createOrder() {
      this.$store.commit('shipment_md/orders/CLEAR_SELECTED_VALUE');
      this.$router.push('/shipment_md/orders/create');
    },
    onRemoveFilter() {
      const unSelectButtons = document.querySelectorAll('.ui-unselect--option');
      unSelectButtons.forEach((el) => {
        el.click();
      });
    },
    isObjectEmpty(object) {
      return isEmpty(object);
    },
    onSelectCompany(newValue, fromInit = false) {
      const { query } = this.$route;
      const companyId = isObject(newValue) ? newValue.id || null : newValue;
      this.$store.commit('shipment_md/orders/SET_COMPANY_ID', companyId);
      this.selectedCompany = companyId;

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...query,
            company_id: companyId,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['company_id']),
          },
        });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectCompany = companyId;
      }
    },
    onSelectCustomer(newValue, fromInit = false) {
      const { query } = this.$route;
      const customerId = isObject(newValue) ? newValue.id || null : newValue;
      this.$store.commit('shipment_md/orders/SET_CUSTOMER_ID', customerId);
      this.selectedCustomer = newValue;

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...query,
            customer_id: customerId,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['customer_id']),
          },
        });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectCustomer = customerId;
      }

      this.destinationList.splice(0);
      this.destinationList = filter(this.locations, { company: { id: customerId } });
      if (!isEqual(customerId, get(this.selectedDestination, 'company.id'))) {
        this.selectedDestination = [];
      }
    },
    onSelectDestination(newValue, fromInit = false) {
      const { query } = this.$route;
      const destinationId = isObject(newValue) ? newValue.id || null : newValue;
      this.$store.commit('shipment_md/orders/SET_DESTINATION_ID', destinationId);
      this.selectedDestination = newValue;

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...query,
            destination_id: destinationId,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['destination_id']),
          },
        });
      }

      if (!fromInit) {
        this.resetPagination();
        this.loadData();
      } else {
        this.initSelectDestination = destinationId;
      }
    },
    onSelectSort(newValue, fromInit = false) {
      const { query } = this.$route;
      const sortValue = isObject(newValue) ? newValue.value || null : newValue;
      this.currentSort = sortValue;
      this.resetPagination();

      if (!isEmpty(newValue)) {
        this.$router.push({
          query: {
            ...query,
            sort: sortValue,
          },
        });
      } else {
        this.$router.push({
          query: {
            ...omit(query, ['sort']),
          },
        });
        return;
      }

      const { id } = this.sortOptions.find(s => s.value === sortValue);
      this.$store.commit('shipment_md/orders/SET_QUERY_SORT', sortValue);

      if (!fromInit) {
        this.loadData();
      } else {
        this.initSelectSort = id;
      }
    },
    loadCompaniesData() {
      return Promise.all([
        this.$store.dispatch('companies/LOAD_SIMPLE_DATA', { tenants: 0 }),
        this.$store.dispatch('companies/LOAD_SIMPLE_DATA', { tenants: 1 }),
      ]).then((data) => {
        const companies = data[0] || [];
        const customers = companies.filter(dt => dt.type === 'CUSTOMER');
        const tenants = data[1];
        this.companiesData = companies;
        this.customersData = !this.isSystemAdmin ? uniqBy(concat(customers, tenants), 'id') : companies;
      });
    },
    previewFiles() {
      this.files = this.$refs.uploadOrder.files;
    },
    onSubmitUpload() {
      const companyId = this.myCompany;
      this.isStillUpload = true;
      this.uploadText = 'Uploading';
      tmsApi.uploadAuth(this.token, { file: this.fileUpload }, {
        company_id: companyId,
        file_type: 'prambanan_routing',
        createShipment: this.fileUploadCreateShipment,
        deliveryDate: format(this.selectedDate, 'YYYY-MM-DD'),
      }).then((res) => {
        const result = get(res, 'result', []);
        if (result.length === 0) {
          let desc = get(result, 'desc', '');
          try {
            desc = JSON.parse(desc);
          } catch (e) {}
          this.uploadText = 'Failed';
          this.uploadResultText = 'Failed Upload File';
          this.$refs.fileInput.reset();
          this.uploadResult = false;
          this.uploadProcessed = true;
          this.isUploadError = true;
          this.errorResultText = typeof desc === 'string' ? [desc] : desc;
        } else {
          const firstResult = result.shift();
          const resp = get(firstResult, 'resp', {});

          let desc = get(resp, 'desc', '');
          try {
            desc = JSON.parse(desc);
          } catch (e) {}

          let isSuccessGenFile = get(resp, 'status', false);
          if (!isSuccessGenFile && typeof desc === 'string') isSuccessGenFile = true;
          if (!isSuccessGenFile && get(desc, 'status', false)) isSuccessGenFile = true;

          if (isSuccessGenFile) {
            this.uploadText = 'Success';
            this.uploadResultText = 'Success Upload File';

            if (typeof desc === 'string') {
              if (desc.toLowerCase().indexOf('error') > -1) {
                this.isUploadError = true;
                this.errorResultText = [desc];
              }
            } else {
               this.isUploadError = true;
               this.errorResultText = get(desc, 'error', []);
            }

            this.$refs.fileInput.reset();
            this.uploadResult = isSuccessGenFile;
            this.uploadProcessed = true;
            this.loadData();
            if (this.fileUploadCreateShipment) {
              this.loadShipments();
            } else {
              this.loadRoutingSummary();
            }
          } else {
            this.uploadText = 'Failed';
            this.uploadResult = false;
            this.uploadProcessed = true;
            this.uploadResultText = 'Failed Upload File';
            this.isUploadError = true;
            this.errorResultText = get(desc, 'error', []);
          }
          this.isStillUpload = false;
        }
      });
    },
    cancelUpload() {
      this.$refs.fileInput.reset();
      this.uploadProcessed = false;
      this.isStillUpload = false;
      this.isUploadError = false;
      this.uploadText = 'Start Upload';
    },
		getRandomColor() {
			var letters = '0123456789ABCDEF';
			var color = '#';
			for (var i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)];
			}
			return color;
    },
    toggleSideBar(show) {
      this.$store.commit('SHOW_HIDE_BREADCRUMB', !show);
      this.$store.commit('SHOW_HIDE_FOOTER', !show);
      if (show) {
        this.$store.commit('MINIMIZE_SIDEBAR');
        document.body.classList.add('sidebar-minimized');
      } else {
        this.$store.commit('RESTORE_SIDEBAR');
        document.body.classList.remove('sidebar-minimized');
      }
    },
    generateLineColor(data) {
      const vehicleLineColors = {};

      data.forEach((dt) => {
        if (isEmpty(dt.vehicle)) return;

        const { vehicle: vehicleData } = dt;
        const { id: vehicleId } = vehicleData;

        if (vehicleLineColors[vehicleId]) return;

        const availableColors = Object.values(vehicleLineColors);
        let color = this.getRandomColor();

        while (availableColors.includes(color)) {
          color = this.getRandomColor();
        }

        vehicleLineColors[vehicleId] = color;
      });

      return vehicleLineColors;
    },
    getLineCollections(data) {
      const shipmentSummaries = cloneDeep(data);
      const fixedLines = shipmentSummaries.reduce((arrLine, dtSummary) => {
        const { vehicle = {}, metadata = {}, deliveries = [] } = dtSummary;
        const { id: vehicleId } = vehicle || {};
        deliveries.forEach((deliv) => {
          const lineString = get(deliv, 'direction.geo_poly') || null;
          if (lineString) {
            lineString.color = this.vehicleLineColors[vehicleId] || 'red';
            arrLine.push(lineString);
          }
        });
        return arrLine;
      }, []);

      return fixedLines;
    },
    getMarkerCollections(data) {
      let points = [];
      data.forEach((dtSummary) => {
        const { metadata = {}, steps = [] } = dtSummary;
        // const { route = {} } = metadata;
        // const { steps = [] } = route;
        const { orders = {} } = dtSummary;

        if (steps) {
          steps.forEach((step, idx) => {
            const { type: stepType, location = [], job: orderId, childs = [], arrival } = step;

            if (stepType === 'end') return;
            // if (orderId === null) return;

            const order = orders.find(dt => (parseInt(dt.id) === parseInt(orderId))) || {};
            const destinationName = order.destination ? order.destination.name : '';
            let sequence = idx;

            if (order.sequence !== null) {
              sequence = order.sequence;
            }

            if (childs) {
              const multiSequnce = [sequence];
              childs.forEach((child) => {
                const { id } = child;
                const childOrder = orders.find(dt => dt.id == id);
                if (childOrder.sequence && !multiSequnce.includes(childOrder.sequence)) {
                  multiSequnce.push(childOrder.sequence);
                }
              });
              sequence = multiSequnce.join(', ');
            }

            const locationType = stepType === 'start' || stepType === 'end'
              ? 'origin'
              : 'destination';
            const lon = parseFloat(location[0]);
            const lat = parseFloat(location[1]);
            points.push({
              geometry: { type: 'Point', coordinates: [lon, lat] },
              type: locationType,
              longitude: lon,
              latitude: lat,
              sequence,
              customer: order.customer,
              name: destinationName,
              arrival,
              job: orderId,
            });
          });
        }

        // const { destinations, origin } = dtSummary;
        // const destinationPoints = destinations.map((dest) => {
        //   const order = first(dest.orders);
        //   const newObj = {
        //     type: 'destination',
        //     sequence: order.sequence,
        //     customer: dest.customer,
        //   };
        //   Object.assign(newObj, order.destination);
        //   return newObj;
        // });

        // origin.type = 'origin';
        // points.push(origin);
        // destinationPoints.forEach((destPoint) => { points.push(destPoint); });
      });

      return points;
    },
    async loadShipments() {
      await this.loadRoutingSummary();

      const selectedDate = format(this.selectedDate, 'YYYY-MM-DD');
      return this.$store.dispatch('shipment_md/shipments/LOAD_SHIPMENTS_BY_RANGE_DATE', {
        start_date: selectedDate,
        end_date: selectedDate,
        state_filter_or: ['CREATED', 'READY_TO_LOAD'],
        filter_by_delivery_date: true,
       })
        .then((data) => {
          if (!data) { data = []; }
          this.shipmentListTable.items = data.map((shipment, i) => {
              const { orders } = shipment;
              shipment.orders = orderBy(orders, ['sequence'], ['asc']);
              shipment.index = i + 1;
            return shipment;
          });
          this.shipmentListTable.totalRows = data.length;
          this.shipments = data.map((shipment) => {
            const { orders } = shipment;
            shipment.orders = orderBy(orders, ['sequence'], ['asc']);
            return shipment;
          });
        });
    },
    shipmentSumFromOrder(shipment, key) {
      return round(sumBy(shipment.orders, (o) => parseFloat(get(o, key, 0))), 2);
    },
    loadRoutingSummary() {
      this.routingSummaryLoading = true;
      const selectedDate = format(this.selectedDate, 'YYYY-MM-DD')
      return this.$store.dispatch('shipment_md/shipments/LOAD_ROUTING_SUMMARY', {
        start_date: selectedDate,
        end_date: selectedDate,
        filter_by_delivery_date: true,
      })
      .then((data) => {
        this.routing_summary = data;
      })
      .finally(() => {
        this.routingSummaryLoading = false;
      });
    },
    loadTodayOrders() {
      return false;
      // const todayDate = format(new Date(), 'YYYY-MM-DD')
      // return this.$store.dispatch('shipment_md/orders/LOAD_DATA', {
      //   start_date: todayDate,
      //   end_date: todayDate,
      //   assigned: false,
      // });
    },
    filterTargetShipmentMove() {
      const isAssign = this.moveTypeAction === 'assign';
      let metadata = {};
      let sourceShipmentId = null;

      if (isAssign) {
        metadata = this.targetMoveOrder.metadata || {};
        const orderStorageConverted = this.checkStorageType(metadata.storage_type);
        metadata.storage_type = orderStorageConverted;
      } else {
        metadata = this.sourceShipmentMove.metadata;
        sourceShipmentId = this.sourceShipmentMove.id;
      }
      const storageType = metadata ? metadata.storage_type : '';

      return (dt) => {
        const dtStorage = this.get(dt, 'metadata.storage_type');
        const sameStorage = dtStorage == storageType;

        // if (isAssign) return sameStorage;
        if (isAssign) return true;

        const notItSelf = dt.id !== sourceShipmentId;
        // return notItSelf && sameStorage;
        return notItSelf;
      };
    },
    prepareShipmentOptions() {
      return (dt) => {
        const plateNo = this.get(dt, 'vehicle.reg_no');
        const storageType = this.get(dt, 'metadata.storage_type');
        const driverName = this.get(dt, 'driver.name');
        // for truck on call
        const isTruck = dt.metadata.hasOwnProperty('truck_on_call_info');
        const truckPlate = this.get(dt, 'metadata.truck_on_call_info.plate_no');
        const truckDriver = this.get(dt, 'metadata.truck_on_call_info.driver');
        let shipmentText = ''
        if(isTruck) {
          shipmentText = `${dt.number} - ${truckPlate} (${truckDriver}) - ${storageType}`;
        } else {
          shipmentText = `${dt.number} - ${plateNo} (${driverName}) - ${storageType}`;
        }
        return { text: shipmentText, value: dt.id };
      };
    },
    onSearchShipmentMove: debounce(function onSearchShipmentMove(value) {
      const searchVal = trim(value);

      let allShipments = this.shipments
        .filter(this.filterTargetShipmentMove())
        .map(this.prepareShipmentOptions());
      allShipments = orderBy(allShipments, ['text'], ['asc']);

      if (!isEmpty(searchVal)) {
        this.shipmentListMoveOrder = allShipments
          .filter(dt => dt.text.toLocaleLowerCase().indexOf(searchVal.toLocaleLowerCase()) > -1);
      } else {
        this.shipmentListMoveOrder = allShipments;
      }
    }, 1e3),
    onOpenedModalMove() {
      const all = this.shipments
        .filter(this.filterTargetShipmentMove())
        .map(this.prepareShipmentOptions());
      this.shipmentListMoveOrder = orderBy(all, ['text'], ['asc']);
    },
    onClosedModalMove() {
      this.targetMoveOrder = null;
      this.sourceShipmentMove = null;
      this.targetShipmentIdMove = null;
      this.shipmentListMoveOrder = [];
      this.searchShipmentValue = '';
    },
    filterTargetShipmentSwitch() {
      return (shipment) => {
        const vehicleId = this.get(shipment, 'vehicle.id');
        const vehicleIdOnCall = this.get(shipment, 'metadata.truck_on_call_info.id');
        const sourceVehicleId = this.get(this.sourceShipmentSwitch, 'vehicle.id');
        const sourceVehicleIdOnCall = this.get(this.sourceShipmentSwitch, 'metadata.truck_on_call_info.id');

        let usedVehicleId = '';
        let usedSourceVehicleId = '';

        let targetStorageType = this.get(shipment, 'metadata.storage_type');
        targetStorageType = this.checkStorageType(targetStorageType);
        let sourceStorageType = this.get(this.sourceShipmentSwitch, 'metadata.storage_type');
        sourceStorageType = this.checkStorageType(sourceStorageType);

        if (vehicleId !== '-') {
          usedVehicleId = vehicleId;
        } else if (vehicleIdOnCall !== '-') {
          usedVehicleId = vehicleIdOnCall;
        }

        if (sourceVehicleId !== '-') {
          usedSourceVehicleId = sourceVehicleId;
        } else if (sourceVehicleIdOnCall !== '') {
          usedSourceVehicleId = sourceVehicleIdOnCall;
        }

        if (usedVehicleId === '-' || usedSourceVehicleId === '-') return false;
        // return (usedVehicleId !== usedSourceVehicleId) && (targetStorageType === sourceStorageType);
        return usedVehicleId !== usedSourceVehicleId;
      };
    },
    onSearchShipmentSwitch: debounce(function onSearchShipmentSwitch(value) {
      const searchVal = trim(value);

      let allShipments = this.shipments
        .filter(this.filterTargetShipmentSwitch())
        .map(this.prepareShipmentOptions());
      allShipments = orderBy(allShipments, ['text'], ['asc']);

      if (!isEmpty(searchVal)) {
        this.shipmentSwitchList = allShipments
          .filter(dt => dt.text.toLocaleLowerCase().indexOf(searchVal.toLocaleLowerCase()) > -1);
      } else {
        this.shipmentSwitchList = allShipments;
      }
    }, 1e3),
    onOpenedModalSwitch() {
      const all = this.shipments
        .filter(this.filterTargetShipmentSwitch())
        .map(this.prepareShipmentOptions());
      this.shipmentSwitchList = orderBy(all, ['text'], ['asc']);
    },
    onClosedModalSwitch() {
      this.sourceShipmentSwitch = null;
      this.targetShipmentSwitchId = null;
      this.shipmentSwitchList = [];
      this.searchShipmentSwitchValue = '';
    },
    openModalChange() {
      this.$refs.modalChange.open();
    },
    startChangeDelivery() {
      const deliveryDate = this.dateFormat(this.selectedChangeDeliveryDate, 'YYYY-MM-DD');
      const orderIds = Object.keys(this.routing_summary)
        .filter(k => this.routing_summary[k].type !== 'assigned')
        .map(k => this.routing_summary[k].orders || [])
        .filter(o => o.length > 0)
        .flat()
        .map(({ id }) => id);
      this.textButtonChangeDeliveryDate = 'Processing...';
      const promises = [];

      orderIds.forEach(id => {
        const payloads = {
          id,
          delivery_date: deliveryDate,
        };
        const promise = this.$store.dispatch('shipment_md/orders/UPDATE_DATA', payloads);
        promises.push(promise);
      });

      Promise.all(promises)
        .then(() => {
          this.textButtonChangeDeliveryDate = 'Change';
          setTimeout(() => {
            this.$refs.modalChange.close();
            this.routingSummaryLoading = true;
            setTimeout(() => {
              this.selectedChangeDeliveryDate = new Date(Date.now() + (24 * 3600 * 1000));
              this.loadShipments();
            }, 5e2);
          }, 1e3);
        })
    },
    closeModalChange() {
      this.$refs.modalChange.close();
    },
    openModalOnCall() {
      this.$refs.modalOnCall.open();
    },
    createOnCall() {
    },
    closeModalOnCall() {
      this.$refs.modalOnCall.close();
    },
    onClickIconMove(sourceShipment = null, order, typeAction = 'move') {
      this.moveTypeAction = typeAction;
      this.sourceShipmentMove = sourceShipment;
      this.targetMoveOrder = order;

      this.$refs.modalAssign.open();
    },
    onClickSwitchVehicle(sourceShipment = null) {
      this.sourceShipmentSwitch = sourceShipment;
      this.$refs.modalSwitch.open();
    },
    parseCustomerAddress(order, keyValue) {
      const address = this.get(order, keyValue);
      return Object.values(address).join(' ');
    },
    onClickIconMoveOrderDetail(data) {
      const order = data.shipment.orders.find(dt => parseInt(dt.id) === parseInt(data.order_id));
      this.onClickIconMove(data.shipment, order);
    },
    onClickIconDeleteOrderDetail(data) {
      const order = cloneDeep(data);
            order.id = order.order_id;
      const shipment = cloneDeep(data.shipment);
      this.onClickDeleteOrder(shipment, order);
    },
    prepareOrderDetail(orders, shipment = {}) {
      return orders.map((order) => {
        return {
            number: this.get(order, 'number'),
            customer_code: this.get(order, 'customer.external_id'),
            customer_name: this.get(order, 'customer.name'),
            customer_address: this.parseCustomerAddress(order, 'customer.address'),
            company: this.get(order, 'company.name'),
            volume: this.get(order, 'metadata.total_gross_volume'),
            weight: this.get(order, 'metadata.total_gross_weight'),
            segment: this.get(order, 'metadata.segment'),
            storage_type: this.get(order, 'metadata.storage_type'),
            truck_type: this.get(order, 'metadata.truck_type'),
            code_route: this.get(order, 'destination.code'),
            total_qty: this.get(order, 'metadata.total_quantity_unit'),
            order_id: this.get(order, 'id'),
            sequence: get(order, 'sequence') + 1,
            shipment,
          };
      });
    },
    toggleOrderDetail(row) {
      row.toggleDetails();
    },
    onClickOrderInfo(order) {
      this.ordersDetail = this.prepareOrderDetail([order]);
      this.$refs.openOrderDetails.open();
      this.tableDetailOrderModal = true;
    },
    closeModalMoveOrder() {
      this.$refs.modalAssign.close();
    },
    closeModalSwitch() {
      this.$refs.modalSwitch.close();
    },
    closeModalOrderDetail() {
      this.tableDetailOrderModal = false;
      this.$refs.openOrderDetails.close();
    },
    addShipmentOrder(shipmentId, orderId) {
      return this.$store.dispatch('shipment_md/shipments/ADD_SHIPMENT_ORDER', {
        shipment_id: shipmentId,
        order_id: orderId,
      });
    },
    removeShipmentOrder(shipmentId, orderId) {
      return this.$store.dispatch('shipment_md/shipments/REMOVE_SHIPMENT_ORDER', {
        shipment_id: shipmentId,
        order_id: orderId,
      });
    },
    recalculateShipmentRoute(shipmentIdA, shipmentIdB) {
      const promises = [
        this.$store.dispatch('shipment_md/shipments/RECALCULATE_SHIPMENT_ROUTE', { shipment_id: shipmentIdA }),
        this.$store.dispatch('shipment_md/shipments/RECALCULATE_SHIPMENT_ROUTE', { shipment_id: shipmentIdB }),
      ];
      return Promise.all(promises);
    },
    recalculateSingleShipmentRoute(shipmentId) {
      return this.$store.dispatch('shipment_md/shipments/RECALCULATE_SHIPMENT_ROUTE', { shipment_id: shipmentId });
    },
    startAssignOrder() {
      const { id: orderId } = this.targetMoveOrder;
      const targetShipmentId = this.targetShipmentIdMove;

      this.textButtonMove = 'Processing...';
      return this.addShipmentOrder(targetShipmentId, orderId).then(() => {
        this.textButtonMove = 'Recalculating...';
        this.recalculateSingleShipmentRoute(targetShipmentId).then(() => {
          this.textButtonMove = 'Move';
          this.loadTodayOrders();
          this.loadShipments();
          this.$refs.modalAssign.close();
        });
      });
    },
    startMoveOrder() {
      const isAssign = this.moveTypeAction === 'assign';

      if (isAssign) return this.startAssignOrder();

      let { id: sourceShipmentId } = this.sourceShipmentMove;
      const { id: orderId } = this.targetMoveOrder;
      const targetShipmentId = this.targetShipmentIdMove;

      if (sourceShipmentId.indexOf('UO') > -1) {
        sourceShipmentId = null;
      }

      const payloads = {
        source_shipment_id: sourceShipmentId,
        target_shipment_id: targetShipmentId,
        order_id: orderId,
      };

      this.textButtonMove = 'Processing...';
      return this.$store.dispatch('shipment_md/shipments/MOVE_SHIPMENT_ORDER', payloads)
        .then(() => {
          this.textButtonMove = 'Move';
          this.loadShipments();
          this.$refs.modalAssign.close();
        })
        .catch(() => {
          console.log(error);
        });
    },
    startSwitchShipment() {
      const sourceShipmentId = get(this.sourceShipmentSwitch, 'id');

      const payloads = {
        source_shipment_id: sourceShipmentId,
        target_shipment_id: this.targetShipmentSwitchId,
      };

      this.textButtonSwitch = 'Processing...';
      return this.$store.dispatch('shipment_md/shipments/SWITCH_SHIPMENT_VEHICLE', payloads)
        .then(() => {
          this.textButtonSwitch = 'Switch';
          this.loadShipments();
          this.$refs.modalSwitch.close();
        })
        .catch(() => {
          console.log(error);
        });
    },
    loadShipmentDebounce: debounce(function loadShipmentDebounce() {
      this.loadShipments();
    }, 5e3),
    loadShipment2() {
      clearTimeout(this.loadShipmentTimer);
      this.loadShipmentTimer = setTimeout(() => {
        this.loadShipments();
      }, 2e3);
    },
    captureSnapshot() {
      if (this.snapshotSaving) {
        clearTimeout(this.snapshotTimer);
        setTimeout(() => {
          this.captureSnapshot();
        }, 1e3);
        return;
      }
      clearTimeout(this.snapshotTimer);
      clearTimeout(this.loadShipmentTimer);
      this.snapshotTimer = setTimeout(() => {
        this.snapshotSaving = true;
        const allShipmentOrders = this.shipments.map((shipment) => {
        const orders = shipment.orders || [];
          return {
            id: shipment.id,
            ordersId: orders.map((o) => o.id),
          };
        });

        this.$bvToast.toast(`Saving shipment order list`, {
          title: 'Please wait',
          autoHideDelay: 5000,
          toaster: 'b-toaster-top-center',
        });

        return this.$store.dispatch('shipment_md/shipments/SET_MULTIPLE_SHIPMENT_ORDERS', allShipmentOrders)
          .then(() => {
            this.loadShipment2();
          })
          .finally(() => {
            this.snapshotSaving = false;
          });
      }, 3e3);
    },
    onMovedOrder(context) {
      let sourceShipmentId = context.from.id.indexOf('UO') === 0 ? null : context.from.id;
      const targetShipmentId = context.to.id;
      const orderId = context.item.id;
      const isSameShipment = sourceShipmentId === targetShipmentId;

      if (sourceShipmentId === null) {
        Object.keys(this.routing_summary).forEach((k) => {
          const rs = this.routing_summary[k];
          const idx = findIndex(rs.orders, o => o.id === orderId);
          rs.orders.splice(idx, 1);
        });
      }

      if (isSameShipment) return false;

      const payloads = {
        source_shipment_id: sourceShipmentId,
        target_shipment_id: targetShipmentId,
        order_id: orderId,
      };

      this.captureSnapshot();
      return true;
    },
    fromOrder(context) {
      this.fromShipment = context.from.id;
    },
    onMoveCallback: debounce(function onMoveCallback({relatedContext, draggedContext}) {
      const toStorage = relatedContext;
      const getFromShipment = this.shipments.find(a => a.number == this.fromShipment)
      const { id: sourceShipmentId } = getFromShipment;
      const getToShipment = this.shipments.find(a => a.number == toStorage.component.$attrs.id)
      const { id: targetShipmentId } = getToShipment;
      const orderId = draggedContext.element.id;

      // filter different order
      // const fromStorage = getFromShipment.metadata.storage_type;
      // if(toStorage == fromStorage) {
      //   return true
      // } else {
      //   return false
      // }

      const payloads = {
        source_shipment_id: sourceShipmentId,
        target_shipment_id: targetShipmentId,
        order_id: orderId,
      };
      return this.$store.dispatch('shipment_md/shipments/MOVE_SHIPMENT_ORDER', payloads)
        .then(() => {
          this.loadShipments();
        })
        .catch(() => {
          console.log(error);
        });
    }, 8e3),
    setStateModalLoading(show, text = '') {
      this.stateLoadText = text;
      if (show) {
        this.$refs.modalLoading.open();
      } else {
        this.$refs.modalLoading.close();
      }
    },
    calculateRoute() {
      this.$swal({
        title: 'Calculate Confirmation',
        text: 'Are you sure want to start calculate shipment route ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.setStateModalLoading(true, 'Please wait while calculating data...');

          const payloads = {
            delivery_date: format(this.selectedDate, 'YYYY-MM-DD'),
          };

          this.$store.dispatch('shipment_md/shipments/CALCULATE_SHIPMENT_ROUTE', payloads).then(() => {
            this.setStateModalLoading(false);
            this.loadShipments();
            this.loadTodayOrders();
          }).catch((error) => {
            console.log(error);
          });
        }
      });
    },
    setReadyToLoad() {
      this.$swal({
        title: 'Confirmation',
        text: 'Are you sure want set all shipments as ready to load ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.setStateModalLoading(true, 'Processing...');

          const payloads = {
            state_filter_or: 'READY_TO_LOAD',
            id: this.shipments.map(dt => dt.id),
          };

          this.$store.dispatch('shipment_md/shipments/UPDATE_STATE_SHIPMENTS', payloads).then(() => {
            this.setStateModalLoading(false);
            this.loadShipments();
            this.loadTodayOrders();
          });
        }
      });
    },
    hasLatLng(order) {
      return get(order, 'destination.latitude', null) !== null && get(order, 'destination.longitude', null) !== null;
    },
    getCustomerInitial(order) {
      const name = get(order, 'customer.name', '');
      const names = name.split(',').map(s => s.trim());
      const firstName = names.shift();
      const initial = firstName.split(/\W+/).map((n) => {
        if (n.match(/^\d+$/)) return n;
        if (n.match(/^[a-z]/)) return '';
        return n[0] || '';
      }).join('');
      // const first4 = initial.substr(0, 4);
      return initial === '' ? '' : ` - ${initial}`;
    },
    checkStorageType(text) {
      if (!text) text = '';

      let storageType = 'Unknown';
      const regExpDry = new RegExp(/\b(AC|DRY|DRIED)\b/i);
      const regExpChiller = new RegExp(/\b(CHILLER|CHILLED|CHILL|CHL)\b/i);
      const regExpFrozen = new RegExp(/\b(FROZEN|FROZ|FRZ|FROZED)\b/i);
      const regExpCombine = new RegExp(/\b(COMBINE|COMBIN)\b/i);
      const isDry = text.match(regExpDry);
      const isChiller = text.match(regExpChiller);
      const isFrozen = text.match(regExpFrozen);
      const isCombine = text.match(regExpCombine);

      if (isDry) {
        storageType = 'DRY';
      } else if (isChiller) {
        storageType = 'CHILLER';
      } else if (isFrozen) {
        storageType = 'FROZEN';
      } else if (isCombine) {
        storageType = 'COMBINE';
      }

      return storageType;
    },
    startExportShipments() {
      this.$swal({
        title: 'Confirmation',
        text: 'Are you sure want to start export shipments to excel ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.setStateModalLoading(true, 'Processing...');

          const selectedDate = format(this.selectedDate, 'YYYY-MM-DD')

          const payloads = {
            startDate: selectedDate,
            endDate: selectedDate,
          };

          this.$store.dispatch('shipment_md/shipments/EXPORT_PRAMBANAN_SHIPMETS', payloads)
            .then((resp) => {
              this.setStateModalLoading(false);
              this.alertExportedShipment = true;
              this.resultExportedShipment = true;
              this.linkFileExportShipment = resp.file;
            })
            .catch((error) => {
              this.setStateModalLoading(false);
              this.alertExportedShipment = true;
              this.resultExportedShipment = false;
            });
        }
      });
    },
    onClickDeleteOrder(shipment, order) {
      this.$swal({
        title: 'Confirmation',
        html: `Are you sure want to delete this order <b>(${order.number})</b> ?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.setStateModalLoading(true, 'Processing...');
          this.$store.dispatch('shipment_md/orders/DELETE_DATA', order.id).then(() => {
            this.setStateModalLoading(false);
            this.recalculateSingleShipmentRoute(shipment.id);
            this.loadShipments();
          });
        }
      });
    },
    onClickCreateOrderLocation(order) {
      this.onClickInvalidDestination(order);
    },
    restartData() {
      const humanizeDate = format(this.selectedDate, 'DD MMM YYYY');
      this.$swal({
        title: 'Confirmation',
        html: `Are you sure want to <b>restart</b> all data ? <br> This will delete all orders and shipments at <b>${humanizeDate}</b>.`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          const selectedDate = format(this.selectedDate, 'YYYY-MM-DD');
          this.setStateModalLoading(true, 'Processing...');
          this.$store.dispatch('shipment_md/shipments/RESTART_SHIPMENT_DATA', {
            start_date: selectedDate,
            end_date: selectedDate,
          }).then(() => {
            this.setStateModalLoading(false);
            this.loadTodayOrders();
            this.loadShipments();
          });
        }
      });
    },
    resetRoute() {
      const humanizeDate = format(this.selectedDate, 'DD MMM YYYY');
      this.$swal({
        title: 'Confirmation',
        html: `Are you sure want to <b>reset</b> calculated route data at <b>${humanizeDate}</b> ?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          const selectedDate = format(this.selectedDate, 'YYYY-MM-DD');
          this.setStateModalLoading(true, 'Processing...');
          this.$store.dispatch('shipment_md/shipments/RESET_CALCULATED_ROUTE_DATA', {
            start_date: selectedDate,
            end_date: selectedDate,
          }).then(() => {
            this.setStateModalLoading(false);
            this.loadTodayOrders();
            this.loadShipments();
          });
        }
      });
    },
    async addDummyShipment() {
      if (this.addShipmentDummyLoading) return false;
      this.textButtonOnCall = 'Processing...';
      this.addShipmentDummyLoading = true;
      const selectedDate = format(this.selectedDate, 'YYYY-MM-DD');
      const plateNo = get(this.onCallTruck, 'plate_no', 'On Call Truck');
      const typeFull = get(this.onCallTruck, 'type_full', 'CDE Chiller Combine');
      const typeShort = typeFull.match(/dry/i) ? 'DRY' : 'CHILL';
      const type = typeFull.match(/combine/i) ? 'COMBINE' : typeShort === 'DRY' ? 'DRY' : 'CHILLER';
      const maxWeight = get(this.onCallTruck, 'max_weight', 2000);
      const maxVolume = get(this.onCallTruck, 'max_volume', 8.96);
      try {
        await this.$store
          .dispatch('shipment_md/shipments/CREATE_DUMMY_SHIPMENT', {
            deliveryDate: selectedDate,
            plateNo,
            typeFull,
            typeShort,
            type,
            maxWeight,
            maxVolume
          })
          .then(() => {
            this.textButtonOnCall = 'Create';
            this.closeModalOnCall()
            this.loadShipments()
          });
      } catch (error) { }
      this.addShipmentDummyLoading = false;
    }
  },
  mounted() {
    this.toggleSideBar(true);
  },
  beforeDestroy() {
    this.toggleSideBar(false);
  },
};
</script>
<style>
.flip-list-move {
  transition: transform 0.5s;
}
.sweet-modal .sweet-title {
  padding-top: 30px
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.header {
  cursor: pointer;
}
.list-group-item i {
  cursor: pointer;
}
</style>
<style lang="sass">
.my-checkbox
  position: relative
  top: 2px
  margin-right: 5px
.table td
  vertical-align: middle
.table-confirm-signature
  height: 80px
  margin: -0.5rem
.remove--filter
  font-weight: bold;
  cursor: pointer;
  color: #e66f6f;
.remove--filter
  i
    font-size: 17px;
.remove--filter:hover
  color: #0366d6;
@media screen and (max-width: 320px)
  .ui-dropdown-modal-holder
    width: 250px !important
.card-columns
  @media (min-width: 2000px)
    column-count: 6;
  @media (min-width: 1600px) and (max-width: 2000px)
    column-count: 5;
  @media (min-width: 1300px) and (max-width: 1600px)
    column-count: 4;
  @media (min-width: 900px) and (max-width: 1300px)
    column-count: 3;
  @media (min-width: 600px) and (max-width: 900px)
    column-count: 2;
  @media (max-width: 600px)
    column-count: 1;

#order-extra-list
  > .tab-content
    border: none
    > .tab-pane
      padding: 0

</style>

<style lang="sass" scoped>

.alert
  left: 0px !important;

.show__loading
  height: 800px
  top: 75px
  width: 96.5%
  position: absolute
  opacity: 0.3
  background-color: #9E9E9E

  >img
    height: 50px
    width: 50px
    margin-left: 50%

.show__blur
  -webkit-filter: blur(1px)
  -moz-filter: blur(1px)
  -ms-filter: blur(1px)
  -o-filter: blur(1px)
  filter: blur(1px)

.fa-modify
  color: #000000;
  margin-left: 45%;

// .order_item--index
//   margin-right: 10px;

// .order_item--action
//   position: absolute;
//   top: 5px;
//   right: 7px;

// .order_item--action .fa-ellipsis-v
//   color: black !important;

// .order_item--action .order_item--action-icon
//   margin-right: 6px;

// .storage-dry
//   background-color: #FFF9C4;

// .storage-chiller
//   background-color: #BBDEFB;

// .storage-frozen
//   background-color: #81D4FA;

// .storage-combine
//   background-color: #A5D6A7;

.target-shipment-list-container
  text-align: left;
  padding-left: 5px;
  padding-top: 10px;
  max-height: 300px;
  overflow-y: auto;

.assign-order, .invalid-destination-text, .order-count
  cursor: pointer;

.setup-check-ava-locations
  margin-left: 11px;
  margin-bottom: 6px;

.available-location-container
  margin-left: 11px;
  margin-bottom: 15px;
  max-height: 150px;
  overflow-y: auto;
</style>



// WEBPACK FOOTER //
// src/views/pages/shipment_md/orders/OrderRouting.vue